import {supabase} from "../../../services/Supabase";

export const OrganisationsService = {
    get: async function(id: string) {
        let { data, error } = await supabase
            .from('organisations')
            .select('*')
            .eq("id", id)
        return data
    },


    view: async function() {
        let { data, error } = await supabase
            .from('organisations')
            .select('*')
        return data
    },

    create: async function(organisation: any) {
        const { data, error } = await supabase
            .from('organisations')
            .insert([
                { id: organisation.id },
            ])
        return data
    },

    update: async function(id: string, organisation: any) {
        const { data, error } = await supabase
            .from('organisations')
            .update([
                { ...organisation },
            ])
            .eq('id', id)
        return data
    },

    remove: async function(id: string)  {
        const { data, error } = await supabase
            .from('organisations')
            .delete()
            .eq('id', id)
        return data
    }
}